module.exports = __webpack_public_path__ + "static/scrum-63b033e5d7518058cfd683253c952797.png";